/** The officers' dashboard, the planning section bar, the no-access page and the admins' activity view (plan F3). */
export default {
  dashboard: {
    title: 'Planning dashboard',
    subtitle: 'Submissions, checks and approvals at a glance.',
    nav: {
      label: 'Planning sections',
      dashboard: 'Dashboard',
      submissions: 'Submissions',
      mySubmissions: 'My submissions',
      registrations: 'Registrations',
      activity: 'Activity',
      settings: 'Settings',
    },
    noAccessTitle: 'No access to Planning',
    noAccessBody:
      'Your account has no Planning role. Ask an administrator to add you to a reviewer or approver group, or to approve your applicant registration.',
    noAccessHome: 'Back to Home',
    quickActions: 'Quick actions',
    newSubmission: 'New submission',
    openStaging: 'Open Peta Staging',
    openApproved: 'Open Peta Diluluskan',
    mapsMissing: 'The planning maps appear once Settings → Planning has been saved.',
    cards: {
      all: 'All submissions',
      awaiting: 'Awaiting review',
      approved: 'Approved',
      returned: 'Returned',
      failed: 'Failed check',
      withdrawn: 'Withdrawn',
      committee: 'At committee',
      refused: 'Refused',
      in_force: 'Permissions in force',
    },
    conversion: 'Latest check per submission',
    conversionInProgress: 'In progress',
    conversionPassed: 'Passed',
    conversionFailed: 'Failed',
    conversionErrored: 'Could not run',
    successRate: 'Success rate',
    successRateHint: 'Passed ÷ (passed + failed). Checks that could not run are left out.',
    successRateNone: 'No finished checks yet',
    storage: 'Storage used',
    storageHint: 'Drawings and derived files; a file kept for several revisions counts once.',
    byStage: 'By stage',
    crsUsage: 'Coordinate systems',
    crsUnknown: 'EPSG {{srid}} (not in the pack)',
    none: 'None yet.',
    recent: 'Recent submissions',
    recentEmpty: 'No submissions yet.',
    viewAll: 'View all submissions',
  },
  activity: {
    title: 'Planning activity',
    subtitle:
      'Who did what in Planning, newest first. Times, IP addresses and browsers are shown where they were recorded.',
    notPermitted: 'Only a tenant administrator can view Planning activity.',
    filterLabel: 'Action',
    allActions: 'All actions',
    columns: {
      time: 'Time',
      action: 'Action',
      actor: 'By',
      target: 'Item',
      ip: 'IP address',
      userAgent: 'Browser (user agent)',
    },
    system: 'System',
    empty: 'No Planning activity has been recorded yet.',
    loadMore: 'Load more',
    loadingMore: 'Loading…',
    targets: {
      planning_case: 'Submission',
      planning_document: 'File',
      planning_registration: 'Registration',
      planning_settings: 'Settings',
      planning_import: 'Package import',
      planning_trusted_system: 'Trusted system',
      planning_register_export: 'District register export',
      planning_letter: 'Decision letter',
      user: 'Person',
    },
    actions: {
      case_created: 'Submission created',
      case_updated: 'Submission edited',
      case_submitted: 'Submitted',
      case_resubmitted: 'Resubmitted',
      case_check_retried: 'Check retried',
      case_approved: 'Approved',
      case_returned: 'Returned',
      case_withdrawn: 'Withdrawn',
      case_deleted: 'Deleted',
      document_uploaded: 'Drawing uploaded',
      document_downloaded: 'File downloaded',
      register_retried: 'Map update retried',
      registration_approved: 'Registration approved',
      registration_rejected: 'Registration rejected',
      registration_password_issued: 'Temporary password issued',
      settings_updated: 'Settings updated',
      chain_broken: 'History failed verification',
      calendar_updated: 'Working-day calendar updated',
      procedure_updated: 'Procedure adjustments saved',
      case_exported: 'Case package export requested',
      case_export_downloaded: 'Case package downloaded',
      case_authority_recalled: 'Case recalled from another system',
      seal_key_rotated: 'Package signing key replaced',
      import_validated: 'Case package checked',
      case_imported: 'Case package imported',
      case_external_id_linked: 'External reference linked',
      trusted_system_updated: 'Trusted system saved',
      trusted_system_deleted: 'Trusted system removed',
      case_transition: 'Procedure step taken',
      case_referral_requested: 'Technical comments requested',
      case_referral_answered: 'Technical comments received',
      case_referral_withdrawn: 'Comment request withdrawn',
      case_linked: 'Submission linked',
      case_unlinked: 'Submission link removed',
      case_assigned: 'Submission assigned',
      case_intake_tool: 'Drawing check tool used',
      letter_prepared: 'Decision letter prepared',
      letter_issued: 'Decision letter issued',
      letter_discarded: 'Decision letter draft discarded',
      letter_shared: 'Decision letter shared with the applicant',
      letter_unshared: 'Decision letter hidden from the applicant',
      letter_email_released: 'Held decision email released',
      letter_signed: 'Signed decision letter verified',
      signing_certificate_requested: 'Signing certificate requested',
      signing_certificate_ready: 'Signing certificate ready',
      signing_certificate_status_changed: 'Signing certificate turned on or off',
      signing_certificate_approved: 'Personal signing certificate approved',
      signing_certificate_deleted: 'Signing certificate deleted',
      letter_sign_requested: 'Decision letter sent for signing in gisify',
      drawing_cleanup_started: 'Drawing clean-up started',
      drawing_cleanup_round_applied: 'Drawing clean-up round applied',
      drawing_cleanup_stopped: 'Drawing clean-up stopped',
      drawing_cleanup_submitted: 'Cleaned drawing used on the case',
      register_exported: 'District register export requested',
      register_export_downloaded: 'District register export downloaded',
      case_external_id_unlinked: 'External reference unlinked',
      case_mirror_marked: 'OSC mirror checklist updated',
      notification_test_sent: 'Test email sent',
      notification_resent: 'Email queued again',
      notification_preferences_updated: 'Email preferences changed',
    },
  },
} as const
